import { Accessor, createEffect } from 'solid-js';
import { CapabilityRegistry } from '@trimble/web3d';

// web3d's point set cache only counts positions (3 x int32) and classification (1 byte).
const CACHE_BYTES_PER_POINT = 13;

// 128 MiB. maxMemoryCache also sizes the trimbim geometry builder cache.
export const MIN_POINT_CACHE_BYTES = 134_217_728;

export function pointCacheBytes(pointBudget: number): number {
  return Math.max(MIN_POINT_CACHE_BYTES, pointBudget * CACHE_BYTES_PER_POINT);
}

// Point sets dropped by the budget stay in web3d's point set cache, which is
// sized from the screen and device memory unless maxMemoryCache is set.
export function applyPointCacheMemoryLimit(
  capabilityRegistry: CapabilityRegistry,
  pointBudget: Accessor<number>
): void {
  createEffect(() => {
    const bytes = pointCacheBytes(pointBudget());
    for (const container of capabilityRegistry.paneContainers()) {
      const settings = container.viewerWrapper()?.viewer.settings;
      // Every write rebuilds and empties the cache.
      if (settings && settings.maxMemoryCache !== bytes) {
        settings.maxMemoryCache = bytes;
      }
    }
  });
}
